/**
 * PE-page error normalization helper.
 *
 * F-AP-PE-PARSE-002 (2026-05-17): when the PE valuation service is not
 * provisioned in the active environment, the platform-admin-api proxy
 * falls through and returns a 404 HTML body (the SPA catch-all
 * index.html). openapi-fetch then calls `response.json()` against that
 * body, which throws a SyntaxError starting with
 *   "Unexpected token '<', '<!doctype...'"
 * The verbatim parse error surfaces in the SPA's red error alert and
 * looks like a JS bug rather than a missing-service operator condition.
 *
 * `mapPeFetchError` converts that JSON-parse class into a single
 * operator-actionable message and returns the original `Error` for
 * everything else. Pages call it from their `catch` block:
 *
 *   } catch (err) {
 *     setError(mapPeFetchError(err, 'load funds'));
 *   }
 *
 * Applies to BOTH peFundClient and peValuationClient call sites because
 * both share the same upstream proxy fall-through behavior.
 */
export function mapPeFetchError(err: unknown, action: string): string {
  if (
    err instanceof SyntaxError ||
    (err instanceof Error &&
      /Unexpected token|<!doctype|is not valid JSON/i.test(err.message))
  ) {
    return `PE valuation is not yet wired in this environment. The PE service endpoint is unavailable; ask an operator to enable PE valuation provisioning for this tenant. (Failed to ${action}.)`;
  }
  return err instanceof Error ? err.message : `Failed to ${action}`;
}
